import { Pipe, PipeTransform } from '@angular/core';
import { reverse } from 'lodash';

@Pipe({
  name: 'reverse',
  standalone: true,
})
export class ReversePipe implements PipeTransform {
  transform(value: any[]): any[] {
    return reverse(value);
  }
}
